import { render, staticRenderFns } from "./InputNumber.vue?vue&type=template&id=0fc395c0&"
import script from "./InputNumber.vue?vue&type=script&lang=ts&"
export * from "./InputNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc395c0')) {
      api.createRecord('0fc395c0', component.options)
    } else {
      api.reload('0fc395c0', component.options)
    }
    module.hot.accept("./InputNumber.vue?vue&type=template&id=0fc395c0&", function () {
      api.rerender('0fc395c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/input/InputNumber.vue"
export default component.exports